function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 16 4 L 16 6 C 21.534534 6 26 10.465466 26 16 C 26 21.534534 21.534534 26 16 26 C 10.465466 26 6 21.534534 6 16 C 6 12.733432 7.585011 9.853231 10 8.03125 L 10 13 L 12 13 L 12 6 L 12 5 L 11 5 L 4 5 L 4 7 L 8.09375 7 C 5.5933985 9.1987134 4 12.416946 4 16 C 4 22.615466 9.3845336 28 16 28 C 22.615466 28 28 22.615466 28 16 C 28 9.3845336 22.615466 4 16 4 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Bitstream Vera Sans"
  }));
};

export default __webpack_public_path__ + "static/media/restart.b7e93d61.svg";
export { SvgComponent as ReactComponent };